module.exports = __webpack_public_path__ + "img/check.19841fbc.svg";